import React, { useState } from 'react'
import * as InterialStyle from "../../styles/dabin/StyledComponenetInterialRenewal";
import background from "../../images/interiorRenewalSplash/image_background.png"

const InteriorRenewalIntroduce = () => {
  const buttons = [
    {text1:"베르판・루체플랜・ 리파",text2:"한국 독점 공식 수입원"},
    {text1:"인테리어 업체 전용",text2:"특별 공급가 제공"},
    {text1:"실시간 재고 확인 및",text2:"견적 자동화 시스템"},
    {text1:"주문부터 시공까지",text2:"원스톱 제공"},
  ]
  const [buttonNumber, setButtonNumber] = useState(0);
  return (
    <div>
      <InterialStyle.InteriorRenewalIntroduceContainer>
        <div className="introduce-background">
          <img className='hero-section_logo' 
            src={background}
            alt="logo" 
          />
        </div>
        <div className="introduce-content">
          <div className="introduce-text-box">
            <h2>AOS</h2>
            <p>
              고급 수입 조명을 직접 제안, 설계, 시공까지 한 번에<br/>
              영업/설계/시공을 연결하는 스마트 B2B 플랫폼
            </p>
          </div>
          <div className="introduce-arrow-box">
            <div className="introduce-arrow_circle"/>
            <div 
              className={`introduce-arrow_second-line active${buttonNumber}`}
            />
          </div>
          <div className="introduce-button-box">
            <ul>
              {buttons.map((tmp, idx) => {
                return(
                  <li
                    onClick={()=>{setButtonNumber(idx)}}
                    className={buttonNumber === idx ? 'active' : ''}
                    key={idx}
                  >
                    <p>
                      {tmp.text1}<br/>
                      {tmp.text2}
                    </p>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </InterialStyle.InteriorRenewalIntroduceContainer>
    </div>
  )
}

export default InteriorRenewalIntroduce